export default "<ng-container #draggableWrapper>\r\n    <ng-content></ng-content>\r\n</ng-container>"